import React from "react";
import { Badge } from "@bookingcom/bui-react";
export default function FareCalendarBadge({ currencyCode, className }) {
    return React.createElement(Badge, { text: `Showing latest prices in ${currencyCode}`, alternative: true, className: className });
}
